
import React, { useEffect, useState } from "react"
import {
    Row,
    Col,
    Card,
    CardBody,
    CardTitle,
    Badge,
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    Form,
    Input,
    Label,
    FormFeedback,
} from "reactstrap"
import { Link } from "react-router-dom"
import { connect } from "react-redux"
import { useFormik } from "formik"
import * as Yup from "yup"

//Import Action to copy breadcrumb items from local state to redux state
import {
    setBreadcrumbItems,
    getCompanies,
    toggleCompanyStatus,
    deleteCompany,
    addNewCompany,
    updateCompany
} from "../../../store/actions"

import "./companies.scss"

const CompaniesList = (props) => {
    document.title = "Gestion des Entreprises | CRM Admin";

    const [modal, setModal] = useState(false)
    const [isEdit, setIsEdit] = useState(false)
    const [currentCompany, setCurrentCompany] = useState(null)

    const breadcrumbItems = [
        { title: "CRM", link: "#" },
        { title: "Admin", link: "#" },
        { title: "Entreprises", link: "#" },
    ]

    useEffect(() => {
        props.setBreadcrumbItems('Entreprises', breadcrumbItems)
        props.getCompanies()
    }, [])

    const toggle = () => {
        if (modal) {
            setModal(false)
            setCurrentCompany(null)
            setIsEdit(false)
        } else {
            setModal(true)
        }
    }

    const handleCompanyClick = arg => {
        const company = arg
        setCurrentCompany({
            id: company.id,
            name: company.name,
            email: company.email,
            phone: company.phone || "",
            address: company.address || "",
            city: company.city || "",
            status: company.status,
        })
        setIsEdit(true)
        toggle()
    }

    const handleDeleteCompany = companyId => {
        if (window.confirm("Êtes-vous sûr de vouloir supprimer cette entreprise ?")) {
            props.deleteCompany(companyId)
        }
    }

    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
            name: (currentCompany && currentCompany.name) || "",
            email: (currentCompany && currentCompany.email) || "",
            phone: (currentCompany && currentCompany.phone) || "",
            address: (currentCompany && currentCompany.address) || "",
            city: (currentCompany && currentCompany.city) || "",
            status: (currentCompany && currentCompany.status) || "active",
        },
        validationSchema: Yup.object({
            name: Yup.string().required("Veuillez saisir le nom de l'entreprise"),
            email: Yup.string().email("Email invalide").required("L'email est requis"),
            status: Yup.string().required("Le statut est requis"),
        }),
        onSubmit: values => {
            if (isEdit) {
                const updateCompanyData = {
                    id: currentCompany.id,
                    ...values,
                }
                props.updateCompany(updateCompanyData)
            } else {
                props.addNewCompany(values)
            }
            toggle()
        },
    })

    return (
        <React.Fragment>
            <Row>
                <Col className="col-12">
                    <Card>
                        <CardBody>
                            <div className="d-flex align-items-center justify-content-between mb-4">
                                <CardTitle className="h4 mb-0">Gestion des Entreprises</CardTitle>
                                <Button color="primary" onClick={toggle}>
                                    <i className="mdi mdi-plus me-1"></i> Ajouter une Entreprise
                                </Button>
                            </div>

                            <div className="table-responsive">
                                <table className="table table-centered table-nowrap mb-0">
                                    <thead className="table-light">
                                        <tr>
                                            <th>Entreprise</th>
                                            <th>Contact</th>
                                            <th>Localisation</th>
                                            <th>Abonnement</th>
                                            <th>Consommation</th>
                                            <th>Statut</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {(props.companies || []).map((company, key) => (
                                            <tr key={key}>
                                                <td>
                                                    <h5 className="font-size-14 mb-1 text-truncate">{company.name}</h5>
                                                    <p className="text-muted mb-0 font-size-12">ID: {company.id}</p>
                                                </td>
                                                <td>
                                                    <div className="font-size-13 mb-1">{company.email}</div>
                                                    <div className="text-muted font-size-11">{company.phone || "N/A"}</div>
                                                </td>
                                                <td>
                                                    <div className="font-size-13">{company.city || "N/A"}</div>
                                                    <div className="text-muted font-size-11">{company.country || "Maroc"}</div>
                                                </td>
                                                <td>
                                                    {company.subscription?.plan ? (
                                                        <>
                                                            <span className="badge badge-soft-primary font-size-12 mb-1">
                                                                {company.subscription.plan.name}
                                                            </span>
                                                            <div className="text-muted font-size-11">
                                                                Exp: {company.subscription.ends_at ? new Date(company.subscription.ends_at).toLocaleDateString() : "N/A"}
                                                            </div>
                                                        </>
                                                    ) : (
                                                        <span className="badge badge-soft-secondary">Pas d'abonnement</span>
                                                    )}
                                                </td>
                                                <td>
                                                    <div className="font-size-12">
                                                        <i className="mdi mdi-account-multiple me-1 text-info"></i>{company.customers_count || 0} Clients<br />
                                                        <i className="mdi mdi-account-star me-1 text-primary"></i>{company.users_count || 0} Users
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="d-flex justify-content-center">
                                                        <span
                                                            className={`badge badge-soft-${company.status === 'active' ? 'success' : company.status === 'pending' ? 'warning' : 'danger'} font-size-12 px-2 py-1`}
                                                        >
                                                            {company.status === 'active' ? 'Actif' : company.status === 'pending' ? 'En attente' : 'Inactif'}
                                                        </span>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className="d-flex gap-2">
                                                        <Button
                                                            color="light"
                                                            size="sm"
                                                            onClick={() => props.toggleCompanyStatus(company.id)}
                                                            title="Toggle Status"
                                                        >
                                                            <i className="mdi mdi-swap-horizontal text-primary"></i>
                                                        </Button>
                                                        <Link
                                                            to={`/admin/companies/${company.id}`}
                                                            className="btn btn-info btn-sm"
                                                        >
                                                            <i className="mdi mdi-eye"></i>
                                                        </Link>
                                                        <Button
                                                            color="primary"
                                                            size="sm"
                                                            onClick={() => handleCompanyClick(company)}
                                                        >
                                                            <i className="mdi mdi-pencil"></i>
                                                        </Button>
                                                        <Button
                                                            color="danger"
                                                            size="sm"
                                                            onClick={() => handleDeleteCompany(company.id)}
                                                        >
                                                            <i className="mdi mdi-trash-can"></i>
                                                        </Button>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </CardBody>
                    </Card>
                </Col>
            </Row>

            <Modal isOpen={modal} toggle={toggle} size="lg">
                <ModalHeader toggle={toggle} tag="h4">
                    {!!isEdit ? "Modifier l'Entreprise" : "Ajouter une Entreprise"}
                </ModalHeader>
                <ModalBody>
                    <Form
                        onSubmit={e => {
                            e.preventDefault()
                            validation.handleSubmit()
                            return false
                        }}
                    >
                        <Row>
                            <Col md={6}>
                                <div className="mb-3">
                                    <Label>Nom de l'Entreprise</Label>
                                    <Input
                                        name="name"
                                        type="text"
                                        placeholder="ex: Ma Société SARL"
                                        onChange={validation.handleChange}
                                        onBlur={validation.handleBlur}
                                        value={validation.values.name || ""}
                                        invalid={validation.touched.name && validation.errors.name ? true : false}
                                    />
                                    {validation.touched.name && validation.errors.name ? (
                                        <FormFeedback type="invalid">{validation.errors.name}</FormFeedback>
                                    ) : null}
                                </div>
                            </Col>
                            <Col md={6}>
                                <div className="mb-3">
                                    <Label>Email Professionnel</Label>
                                    <Input
                                        name="email"
                                        type="email"
                                        placeholder="ex: contact@societe.com"
                                        onChange={validation.handleChange}
                                        onBlur={validation.handleBlur}
                                        value={validation.values.email || ""}
                                        invalid={validation.touched.email && validation.errors.email ? true : false}
                                    />
                                    {validation.touched.email && validation.errors.email ? (
                                        <FormFeedback type="invalid">{validation.errors.email}</FormFeedback>
                                    ) : null}
                                </div>
                            </Col>
                        </Row>

                        <Row>
                            <Col md={6}>
                                <div className="mb-3">
                                    <Label>Téléphone</Label>
                                    <Input
                                        name="phone"
                                        type="text"
                                        placeholder="ex: +212 600 000 000"
                                        onChange={validation.handleChange}
                                        onBlur={validation.handleBlur}
                                        value={validation.values.phone || ""}
                                    />
                                </div>
                            </Col>
                            <Col md={6}>
                                <div className="mb-3">
                                    <Label>Statut</Label>
                                    <Input
                                        name="status"
                                        type="select"
                                        className="form-select"
                                        onChange={validation.handleChange}
                                        onBlur={validation.handleBlur}
                                        value={validation.values.status || "active"}
                                    >
                                        <option value="active">Actif</option>
                                        <option value="inactive">Inactif</option>
                                        <option value="pending">En attente</option>
                                    </Input>
                                </div>
                            </Col>
                        </Row>

                        <Row>
                            <Col md={8}>
                                <div className="mb-3">
                                    <Label>Adresse</Label>
                                    <Input
                                        name="address"
                                        type="text"
                                        placeholder="ex: 123 Bd Mohammed V"
                                        onChange={validation.handleChange}
                                        onBlur={validation.handleBlur}
                                        value={validation.values.address || ""}
                                    />
                                </div>
                            </Col>
                            <Col md={4}>
                                <div className="mb-3">
                                    <Label>Ville</Label>
                                    <Input
                                        name="city"
                                        type="text"
                                        placeholder="ex: Casablanca"
                                        onChange={validation.handleChange}
                                        onBlur={validation.handleBlur}
                                        value={validation.values.city || ""}
                                    />
                                </div>
                            </Col>
                        </Row>

                        <Row>
                            <Col>
                                <div className="text-end">
                                    <Button type="button" color="secondary" className="me-2" onClick={toggle}>Annuler</Button>
                                    <Button type="submit" color="success">
                                        {isEdit ? "Mettre à jour" : "Créer l'Entreprise"}
                                    </Button>
                                </div>
                            </Col>
                        </Row>
                    </Form>
                </ModalBody>
            </Modal>
        </React.Fragment>
    )
}

const mapStateToProps = state => {
    return {
        companies: state.Companies.companies,
    }
}

export default connect(mapStateToProps, {
    setBreadcrumbItems,
    getCompanies,
    toggleCompanyStatus,
    deleteCompany,
    addNewCompany,
    updateCompany
})(CompaniesList)
